import { Field, FieldContainer, Label, RadioGroup } from '@cademy-ui/form';
import { FunctionComponent, useId } from 'react';
import styles from './styles.module.scss';
import { CourseKeyword } from '@shared/types';
import { Button } from '../../../Button';

export type BookerIsAttendingFieldProps = {
    name: string;
    courseKeyword?: CourseKeyword;
};

export const BookerIsAttendingField: FunctionComponent<BookerIsAttendingFieldProps> = ({
    name,
    courseKeyword,
}) => {
    const id = useId();
    return (
        <Field<boolean> name={name} initialValue={true} required={true}>
            {({ value, setValue, descriptionId, errorId, errors }) => {
                return (
                    <FieldContainer
                        className={styles.container}
                        descriptionId={descriptionId}
                        errorId={errorId}
                        errors={errors}
                    >
                        <Label id={`${id}_isAttendingSelect`}>
                            Will you attend this {courseKeyword || 'event'}?
                        </Label>
                        <RadioGroup
                            aria-labelledby={`${id}_isAttendingSelect`}
                            className={styles.select}
                            options={[true, false]}
                            value={value}
                            onChange={setValue}
                        >
                            {({ option, isSelected }) => {
                                const text =
                                    option === false ? 'No, I am booking for someone else' : 'Yes';
                                return (
                                    <Button preset={isSelected ? 'primary' : 'default'}>
                                        {text}
                                    </Button>
                                );
                            }}
                        </RadioGroup>
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
